import React from 'react'
import './App.css'
import AllRoutes from './routes'
import { useDispatch } from 'react-redux'
import { setisAuthenticated } from './redux/globalSlice'

function App() {
  const dispatch = useDispatch()
  const storedAttributes = localStorage.getItem('userAttributes')
  const attributes = JSON.parse(storedAttributes)

  if (attributes) {
    dispatch(setisAuthenticated(true))
  }
  return <AllRoutes />
}

export default App
